import { Component, Input, Output, SimpleChanges, EventEmitter, ViewChild } from '@angular/core';
import { TemplateManagerService } from '../shared/services/template-manager.service';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { Template } from '../../core/models/template.model';
import { MainReportText, FinalExecutedHistory } from '../assist-data-element/assist-data-element.component';
import { SimulatorEngineService } from '../../core/services/simulator-engine.service';
import { Diagram } from '../../core/models/diagram.model';
import { BaseDataElement } from '../../core/elements/models/base-data-element.model';
import { InputData } from '../../core/models/input-data.model';
import { ReportTextPosition } from '../../core/models/report-text.model';
import { ChoiceDataElement } from '../../core/elements/models/choice-data-element-model';
const $ = require('jquery');

@Component({
  selector: 'acr-assist-simulator',
  template: `<ng-container *ngIf="!isEmptyContent">
  <div id="topReportTextPosition" *ngIf="reportTextPosition === position.Top">
    <div class="col-sm-12 col-md-12 col-lg-12">
      <div id="div-simulator-block">
        <div class="box box-primary box-solid margin-b-0">
          <div *ngIf="resetButton == true" class="with-border  text-right padding-5 padding-r-10">
            <button (click)="resetElements()" class="btn btn-xs btn-primary">Reset Values</button>
          </div>
          <div class="box-body">
            <div #simulatorResultsBlock>
              <ng-container *ngIf="resultText !== undefined">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h3 class="box-title">Report Text</h3>
                    <div class="box-tools pull-right">
                      <button type="button" class="btn btn-box-tool btn-report-text" (click)="collapseReportText()">
                        <i id="icon_reporttext" class="fa fa-minus"></i>
                      </button>
                    </div>
                  </div>
                  <div id="body_reporttext" class="box-body report-text div-report-text-scroll">
                    <dl>
                      <acr-assist-report-text [reportText]="resultText"></acr-assist-report-text>
                    </dl>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="padding-r-10 scroll" acrDynamicHeightDirective [simulatorElement]="simulatorResultsBlock">
              <form class="form-horizontal">
                <acr-assist-data-element [dataElements]="dataElements" [templatePartial]="template.templatePartial"
                  [endPointXMLString]="template.endPointsString" [imagePath]="imagePath" [xmlContent]="template.xmlContent"
                  (returnReportText)='recieveReportText($event)' [inputValues]="inputValues" [isReset]="isReset"
                  (returnDataElementChanged)='recivedOnDataElementChanged($event)' (returnExecutionHistory)='recievedExecutionHistory($event)'></acr-assist-data-element>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="rightReportTextPosition" *ngIf="reportTextPosition === position.Right">
    <div class="col-sm-6 col-md-6 col-lg-6">
      <div id="div-simulator-block">
        <div class="box box-primary box-solid margin-b-0">
          <div *ngIf="resetButton == true" class="with-border text-right padding-5 padding-r-10">
            <button (click)="resetElements()" class="btn btn-xs btn-primary">Reset Values</button>
          </div>
          <div class="box-body">
            <div id="div-simulator-form" class="padding-r-10 div-simulator-form-height">
              <form class="form-horizontal">
                <acr-assist-data-element [dataElements]="dataElements" [templatePartial]="template.templatePartial"
                  [endPointXMLString]="template.endPointsString" [imagePath]="imagePath" [xmlContent]="template.xmlContent"
                  (returnReportText)='recieveReportText($event)' [inputValues]="inputValues" [isReset]="isReset"
                  (returnDataElementChanged)='recivedOnDataElementChanged($event)' (returnExecutionHistory)='recievedExecutionHistory($event)'></acr-assist-data-element>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-6">
      <div #simulatorResultsBlock>
        <ng-container *ngIf="resultText !== undefined">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Report Text</h3>
              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool btn-report-text" (click)="collapseReportText()">
                  <i id="icon_reporttext" class="fa fa-minus"></i>
                </button>
              </div>
            </div>
            <div id="body_reporttext" class="box-body report-text">
              <dl>
                <acr-assist-report-text [reportText]="resultText"></acr-assist-report-text>
              </dl>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="col-sm-6 col-md-6 col-lg-6">
      <ng-container *ngIf="showKeyDiagram === true">
        <div class="box box-primary margin-b-0">
          <div class="box-header with-border">
            <h3 class="box-title">Key Images</h3>
            <input #imageUpload id="diagramUpload" class="hidden" type="file" accept="image/*" multiple (change)="changeListener($event)">
            <label for="diagramUpload" class="btn btn-success bg-olive margin-10" title="Choose Diagrams">Choose a
              Diagram</label>
            <div class="pull-right padding-l-5">
              <button type="button" class="btn btn-box-tool" data-widget="collapse" (click)="collapseKeyDiagram()">
                <i id="icon_keydiagram" class="fa fa-minus"></i>
              </button>
            </div>
            <div class="pull-right padding-l-5">
              <button type="button" class="btn btn-zoom btn-sm" onclick="zoomIn()">
                <i class="fa fa-search-plus fa-lg"></i>
              </button>
            </div>
            <div class="pull-right padding-l-5">
              <button type="button" class="btn btn-zoom btn-sm" onclick="zoomOut()">
                <i class="fa fa-search-minus fa-lg"></i>
              </button>
            </div>
            <div [hidden]="!isInvalidFile" class="error-msg">Only image files are supported !!!</div>
          </div>
          <div id="body_keydiagram" class="box-body">
            <div id="carousel-example-generic" class="carousel slide scroll" data-interval="false" data-ride="carousel"
              acrDynamicHeightDirective [carouselElement]="simulatorResultsBlock">
              <div class="carousel-inner">
                <ng-container *ngFor="let diagram of keyDiagrams; let i = index">
                  <div class="item zoom" [ngClass]="{'active': diagram.keyDiagram}">
                    <drag-scroll>
                      <img drag-scroll-item id="map_id_{{ i }}" class="img-responsive img-decissionTree" src="{{ diagram.location }}">
                    </drag-scroll>
                  </div>
                </ng-container>
              </div>
              <ng-container *ngIf="keyDiagrams && keyDiagrams.length > 1">
                <a class="left carousel-control" href="#carousel-example-generic" data-slide="prev">
                  <span class="fa fa-angle-left slide-left"></span>
                </a>
                <a class="right carousel-control" href="#carousel-example-generic" data-slide="next">
                  <span class="fa fa-angle-right slide-right"></span>
                </a>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>`,
  styles: [``, `.required-field{color:red}.padding-l-5{padding-left:5px}.whitespace{margin-left:5px}.max-w-h-100{max-width:100%;max-height:100%}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.carousel-control.left{background-repeat:repeat-x}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control.right{background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.scroll{overflow-y:scroll;overflow-x:hidden}.div-simulator-form-height{height:calc(100vh - 100px);overflow-y:scroll;overflow-x:hidden}.div-report-text-scroll{overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 300px)}.padding-r-10{padding-right:10px}.slide-left{left:30px}.slide-right{right:30px}hr{margin-top:10px;margin-bottom:10px}.white-space-line{white-space:pre-line;word-wrap:break-word}p{margin:0 0 10px}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}h4.modal-title.float-left{float:left}.margin-b-0{margin-bottom:0}.font-weight-400{font-weight:400}.custom-radio-style{float:left;margin-right:15px}.zoom{width:100%;overflow:auto}.zoom img{height:auto;width:100%;min-width:100%;max-width:inherit!important}.btn-zoom{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-zoom.hover,.btn-zoom:active,.btn-zoom:hover{background-color:#e7e7e7}@media (min-width:768px){label.control-label{padding-left:20px}}.padding-5{padding:5px}`]
})
export class AcrAssistSimulatorComponent implements OnChanges {
  @Input() templateContent: string;
  @Input() imagePath: string;
  @Input() showKeyDiagram: boolean;
  @Input() reportTextPosition: ReportTextPosition;
  @Input() inputValues: InputData[] = [];
  @Input() inputData: string;
  @Input() resetButton: Boolean = true;
  @Output() returnExecutionHistory: EventEmitter<FinalExecutedHistory> = new EventEmitter<FinalExecutedHistory>();
  @Output() returnDataElementChanged: EventEmitter<InputData[]> = new EventEmitter<InputData[]>();
  @Output() returnDefaultElements = new EventEmitter();
  @ViewChild('imageUpload') imageUpload: any;
  template: Template;
  isEmptyContent: boolean;
  keyDiagrams: Diagram[];
  resultText: MainReportText;
  isReset: boolean;
  dataElements: BaseDataElement[];
  position = ReportTextPosition;
  isInvalidFile: boolean;
  acceptedFileTypes = ['image/png', 'image/gif', 'image/jpg', 'image/jpeg'];

  constructor(private templateManagerService: TemplateManagerService, private simulatorEngineService: SimulatorEngineService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.isReset = true;
    this.isEmptyContent = this.templateContent === undefined || this.templateContent.length === 0 && this.inputValues.length === 0 &&
      this.inputData === undefined;
    if (this.isEmptyContent) {
      return;
    }
    if (this.inputData !== undefined) {
      if (this.inputData.length > 0) {
        this.inputValues = JSON.parse(this.inputData);
      }
    }
    if (this.imageUpload !== undefined) {
      this.imageUpload.nativeElement.value = '';
    }

    this.template = this.templateManagerService.getTemplate(this.templateContent);
    // this.simulatorEngineService.initialize(this.template);
    if (this.inputValues.length !== 0) {
      this.populateTestCaseData();
    }
    this.simulatorEngineService.initialize(this.template);
    this.dataElements = this.template.dataElements;
    this.keyDiagrams = new Array<Diagram>();

    for (let index = 0; index < this.template.metadata.diagrams.length; index++) {
      const element = new Diagram();
      element.label = this.template.metadata.diagrams[index].label;
      element.location = this.imagePath + '/' + this.template.metadata.diagrams[index].location;
      element.keyDiagram = this.template.metadata.diagrams[index].keyDiagram;
      this.keyDiagrams.push(element);
    }

    this.resultText = undefined;
  }

  resetElements() {
    this.template = this.templateManagerService.getTemplate(this.templateContent);
    this.simulatorEngineService.initialize(this.template);
    this.dataElements = Object.assign({}, this.template.dataElements);
    this.resultText = undefined;
    this.returnDefaultElements.emit();
  }

  recieveReportText(textReport: MainReportText) {
    this.resultText = textReport;
  }

  recievedExecutionHistory(finalExecutionHistory: FinalExecutedHistory) {
    this.returnExecutionHistory.emit(finalExecutionHistory);
  }
  recivedOnDataElementChanged(data: InputData[]) {
    this.returnDataElementChanged.emit(data);
  }

  changeListener(event): void {
    this.isInvalidFile = false;
    this.keyDiagrams = new Array<Diagram>();

    for (let i = 0; i < event.target.files.length; i++) {
      const reader = new FileReader();
      const diagram = new Diagram();
      diagram.label = event.target.files[i].name;
      diagram.keyDiagram = i === 0 ? true : false;

      if (!(this.acceptedFileTypes.indexOf(event.target.files[i].type) > -1)) {
        this.isInvalidFile = true;
      }

      reader.onload = (event1: any) => {
        diagram.location = reader.result.toString();
      };

      reader.readAsDataURL(event.target.files[i]);

      reader.onloadend = (event1: any) => {
        this.keyDiagrams.push(diagram);
      };
    }
  }

  collapseKeyDiagram() {
    if ($('#icon_keydiagram').hasClass('fa fa-minus')) {
      $('#icon_keydiagram').removeClass('fa fa-minus');
      $('#icon_keydiagram').addClass('fa fa-plus');
      $('#body_keydiagram').css({
        'display': 'none'
      });
    } else {
      $('#icon_keydiagram').removeClass('fa fa-plus');
      $('#icon_keydiagram').addClass('fa fa-minus');
      $('#body_keydiagram').removeAttr('style');
    }
  }

  collapseReportText() {
    if ($('#icon_reporttext').hasClass('fa fa-minus')) {
      $('#icon_reporttext').removeClass('fa fa-minus');
      $('#icon_reporttext').addClass('fa fa-plus');
      $('#body_reporttext').css({
        'display': 'none'
      });
    } else {
      $('#icon_reporttext').removeClass('fa fa-plus');
      $('#icon_reporttext').addClass('fa fa-minus');
      $('#body_reporttext').removeAttr('style');
    }
  }

  populateTestCaseData() {
    this.template.dataElements.forEach(dataeElement => {
      const inputValue = this.inputValues.filter(x => x.dataElementId.toUpperCase() === dataeElement.id.toUpperCase());
      if (inputValue !== undefined && inputValue.length > 0) {
        if (dataeElement.dataElementType === 'ChoiceDataElement' || dataeElement.dataElementType === 'MultiChoiceDataElement') {
          const choiceElement = <ChoiceDataElement>dataeElement;
          if (Array.isArray(inputValue[0].dataElementValue)) {
            const values = [];
            choiceElement.choiceInfo.forEach(choice => {
              inputValue[0].dataElementValue.forEach(value => {
                if (choice.value.toUpperCase() === value.toUpperCase()) {
                  values.push(choice.value);
                }
              });
            });
            inputValue[0].dataElementValue = values;
          } else {
            choiceElement.choiceInfo.forEach(choice => {

              if (inputValue[0].dataElementValue !== undefined) {
                if (choice.value.toUpperCase() === inputValue[0].dataElementValue.toUpperCase()) {
                  inputValue[0].dataElementValue = choice.value;
                  return;
                }
              }

            });
          }
        }
        dataeElement.currentValue = inputValue[0].dataElementValue;

      }
    });
  }
}
